import { useUpdateCustomerGroupSettings } from '../../../../customer-groups';

/**
 * Assign a single price list to a customer group. Thin wrapper over the group-settings mutation: the
 * step only ever runs while no group has a price list (it completes the moment one does), so this
 * sets the group's selection rather than merging with an existing one.
 */
export function useAssignPriceList() {
  const mutation = useUpdateCustomerGroupSettings();

  return {
    isPending: mutation.isPending,
    isError: mutation.isError,
    assign: (groupSlug: string, priceListSlug: string) =>
      mutation.mutate({
        slug: groupSlug,
        settings: { priceListSelection: [{ price_list_slug: priceListSlug }] },
      }),
  };
}
